/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from "react";

import classnames from "classnames";
import { Divider, Tabs } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
// Helpers
import { ROUTES_PATH } from "routes";
import { GlobalContext } from "contexts/GlobalContext";
// Styles
import "./Navbar.scss";
import NavbarMenu from "./NavbarMenu";
import { NAVBAR_NAMES } from "constants/navbar";
import { trackNavbarTab } from "helpers/googleAnalyticsHelper";

const Navbar = ({ navTabs }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState("");
  const lastNavbarTabEventRef = useRef({ tab: null, at: 0 });

  const tabsText = useMemo(() => {
    return navTabs;
  }, [navTabs]);

  const onTabClick = useCallback(
    (tabClicked, e) => {
      // Allow right-click and middle-click to work as normal links
      if (
        e &&
        e.preventDefault &&
        (e.button === 1 || e.button === 2 || e.ctrlKey || e.metaKey)
      ) {
        return; // Let the browser handle it
      }

      // Prevent default for left-click to use React Router navigation
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      if (tabClicked === NAVBAR_NAMES.PROFILE) {
        setActiveTab("");
        navigate(ROUTES_PATH.PROFILE.index);
        return;
      }
      const now = Date.now();
      const last = lastNavbarTabEventRef.current;
      if (!(last.tab === tabClicked && now - last.at < 400)) {
        lastNavbarTabEventRef.current = { tab: tabClicked, at: now };
        trackNavbarTab(tabClicked);
      }
      navTabs.forEach((item) => {
        setActiveTab(item.label);

        if (item.label === tabClicked) navigate(item.path);
      });
    },
    [navigate, navTabs]
  );

  const showTabs = useMemo(() => {
    if (!tabsText.length) return;
    return tabsText.map((item) => {
      return {
        label: (
          <a
            href={item.path}
            onClick={(e) => {
              // Only prevent default for left-click without modifiers
              if (e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                e.preventDefault();
                onTabClick(item.label, e);
              }
            }}
            onAuxClick={(e) => {
              if (e.button === 1) {
              }
            }}
            onContextMenu={(e) => {}}
          >
            {item.label}
          </a>
        ),
        key: item.label,
        id: item.key,
      };
    });
  }, [tabsText, onTabClick]);

  useEffect(() => {
    const removeSlashes = location.pathname.replace(/[^a-zA-Z]/g, "");
    const findName = navTabs.find((item) => {
      return (
        item.path.replace(/[^a-zA-Z]/g, "").toLowerCase() === removeSlashes
      );
    });
    setActiveTab(findName.label);
  }, [location.pathname, navTabs]);

  const isPricerActive =
    window.location.pathname.indexOf(ROUTES_PATH.PRICER) > -1;
  return (
    <div
      className={classnames(
        dark_Theme || false ? "header__controls_dark" : "header__controls",
        { "header__controls--expand-to-full-screen-width": !isPricerActive }
      )}
    >
      <Tabs
        key={location.pathname}
        activeKey={activeTab}
        className="header-tabs"
        onChange={(tab) => onTabClick(tab)}
        items={showTabs}
        id="header-tabs"
        popupClassName={dark_Theme ? "nav-tabs-dropdown-dark" : ""}
      />

      <Divider key={"vertical"} type="vertical" className="vertical--divider" />
      <h3 key={"logo"} className="header--logo">
        {NAVBAR_NAMES.ARATUS}
      </h3>

      <NavbarMenu onTabClick={onTabClick} />
    </div>
  );
};

export default Navbar;
